import { useCallback, useState } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import type { VerificationEmailProps } from './useVerificationEmail';

export type EmailResendDialogProps = {
  isOpenDialog: boolean;
  openDialogWithSendVerificationEmail: () => Promise<void>;
  setIsOpenDialog: (isOpen: boolean) => void;
};

export function useEmailResendDialog({
  sendVerificationEmail,
}: Pick<VerificationEmailProps, 'sendVerificationEmail'>): EmailResendDialogProps {
  const { showBoundary } = useErrorBoundary();
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const openDialogWithSendVerificationEmail = useCallback(async () => {
    const result = await sendVerificationEmail();
    if (result.response.ok) {
      setIsOpenDialog(true);
      return;
    }
    showBoundary(result.error);
  }, [sendVerificationEmail, showBoundary]);
  return {
    isOpenDialog,
    openDialogWithSendVerificationEmail,
    setIsOpenDialog,
  };
}
